import { useState } from "react";
import { useConsent } from "../../contexts/ConsentContext";
import CookieSettingsModal from "./CookieSettingsModal";
import { useLanguage } from "../../contexts/LanguageContext";

const CookieBanner = () => {
  const { consent, isLoading, saveConsent } = useConsent();
  const [settingsOpen, setSettingsOpen] = useState(false);
  const { translations, language } = useLanguage();

  // Don't render anything while checking consent status
  if (isLoading || consent) return null;

  const handleAcceptAll = () => {
    const consentData = {
      categories: {
        necessary: true,
        analytics: true,
        marketing: true,
      },
      allAccepted: true,
      createdAt: new Date().toISOString(),
    };

    saveConsent(consentData);
  };

  const title =
    translations?.cookieBanner?.title || "Supreme Edits Cookie Consent";

  const description =
    translations?.cookieBanner?.description ||
    "We use cookies and similar technologies to operate and secure the Supreme Edits platform, improve performance, and help us understand how DJs use the platform. This allows us to continuously improve the music library, platform features, and overall user experience. By selecting \"Accept All\", you consent to the use of analytics and marketing technologies. By selecting \"Settings\", you can manage your cookie preferences and choose which categories you allow. Strictly necessary cookies are always active because they are required for the platform to function properly. You can update your preferences at any time via the \"Manage Cookie Consent\" option available in your dashboard. For more information, please review our ";

  return (
    <div className="fixed inset-x-0 bottom-0 z-50 bg-[#010204] px-5 lg:px-10 xl:px-20 py-3 lg:py-7">
      <div className="relative mx-auto flex flex-col sm:flex-row w-full items-center justify-between">
        <div className="relative flex flex-col sm:flex-row ">
          <div className="w-full sm:pr-4">
            <h2 className="text-base sm:text-lg xl:text-xl font-bold text-transparent bg-[linear-gradient(180deg,#52FAF0_31%,#197AD0_91.1%)] bg-clip-text">
              {title}
            </h2>
            <div className="font-normal text-[10px] sm:text-xs xl:text-sm text-[#A5A5A5] leading-3 tracking-normal mt-2 sm:mt-3 xl:mt-4">
              {description}
              <a href="/privacy-policy" className="underline">
                Privacy Policy.
              </a>
            </div>
          </div>
        </div>
        <div className="flex flex-col xs:flex-row sm:flex-col w-full justify-center sm:w-auto gap-3 flex-shrink-0 mt-4 sm:mt-0">
          <button
            type="button"
            onClick={handleAcceptAll}
            className="w-full xs:w-[200px] h-[44px] rounded-[2px] bg-gradient-to-r from-cyan-500 to-blue-500 text-black font-poppins text-base xl:text-lg leading-5 font-semibold hover:opacity-90"
          >
            Accept All
          </button>
          <button
            type="button"
            className="flex items-center justify-center bg-[#000101] 
              font-poppins text-white font-semibold rounded-[2px] relative z-10 transition-all duration-300 
              w-full xs:w-[200px] h-[44px]
              border-2 border-transparent bg-gradient-to-b from-[#52FAF0] via-[#36BAE0] to-[#197AD0] bg-origin-border"
            style={{
              backgroundImage:
                "linear-gradient(#000101, #000101), linear-gradient(180deg, #52FAF0 1.84%, #36BAE0 21.65%, #197AD0 106.4%)",
              backgroundClip: "padding-box, border-box",
              backgroundOrigin: "border-box",
            }}
            onClick={() => setSettingsOpen(true)}
          >
            Settings
          </button>
        </div>
        <div
          className="
          absolute
          top-[80%] left-[45px]
          w-[90%] h-[70%]
          opacity-70
          rounded-[50%]
          blur-[120px]
          pointer-events-none
          bg-[linear-gradient(180deg,#4EEEE4_0%,#1874C0_34.14%)]
          z-50
        "
        />
      </div>
      <CookieSettingsModal
        isOpen={settingsOpen}
        onClose={() => setSettingsOpen(false)}
      />
    </div>
  );
};

export default CookieBanner;
